import { Box, Typography } from '@mui/material';
import Container from '../../components/LandingPage/Container';

const Signature: React.FC = () => {
  return (
    <Box bgcolor="var(--acer-green)" marginTop={{ xs: '0', lg: '28px' }} padding="51px 0">
      <Container>
        <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
          <Box display="flex" flexDirection="column" gap="25px" width={{ xs: '100%', lg: '568px' }}>
            <Typography fontSize="28px" fontWeight="700" lineHeight="36px" letterSpacing="0">
              Quer receita recorrente?
              <br />
              <span style={{ fontWeight: '400' }}>Conheça a modalidade de assinatura mensal</span>
            </Typography>
            <Typography fontSize="16px" fontWeight="400" lineHeight="29px" letterSpacing="0">
              Além das vendas tradicionais, sua empresa também pode lucrar com contratos mensais de
              equipamentos. A Acer atende diretamente o cliente e você recebe comissões mensais.
              Simples, escalável e com receita previsível.
            </Typography>
          </Box>
          <Box
            display={{ xs: 'none', lg: 'flex' }}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            position="relative"
          >
            <Box position="absolute" top="-79px" right="0">
              <img src="/images/signature.png" alt="Signature" />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Signature;
